import React from 'react';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom';

import routes from './routes';
import {generateAppRoutes} from "./breadcrumb/utils";
import Breadcrumb from "./breadcrumb/breadcrumb";
import Title from "./breadcrumb/title";
import InitApp from "./screens/InitApp";
import Header from "./components/header";
import {createBrowserHistory} from 'history';
import Security from "./components/security";

const appRoutes = generateAppRoutes(routes);
const history = createBrowserHistory();

const redirect = () => {
    if (!Security.isInit() || !Security.isAuthenticated()) {
        Security.firstPath = window.location.pathname;
    }

    return <Redirect to={process.env.APP_ROOT}/>;
};

function Router(props) {
    return (
        <BrowserRouter history={history}>
            <Header/>
            <main>
                <Switch>
                    <Route exact={true} key={process.env.APP_ROOT} path={process.env.APP_ROOT} component={InitApp}/>
                    {appRoutes.map(route => (
                        !route.first && route.component && props.isConnected ?
                            <Route exact={route.exact} key={route.path} path={route.path}>
                                {!route.title && route.parent && <Breadcrumb className="wrapper" route={route}/>}
                                {route.title && <Title route={route}/>}
                                <route.component/>
                            </Route> : ""
                    ))}
                    {redirect()}
                </Switch>
            </main>
        </BrowserRouter>
    );
}

export default Router;